import React, { createContext, useContext } from 'react';
import { useAppStore } from '../../store/app/appStore';

type OpenType = 'fullscreen' | 'ingame';

interface OpenTypeContextValue {
  openType: OpenType;
}

const OpenTypeContext = createContext<OpenTypeContextValue | undefined>(undefined);

export const OpenTypeProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  // Get openType from store to support dynamic updates
  const openType = useAppStore((state) => state.settings.openType);

  return (
    <OpenTypeContext.Provider value={{ openType }}>
      {children}
    </OpenTypeContext.Provider>
  );
};

export const useOpenType = () => {
  const context = useContext(OpenTypeContext);
  if (!context) {
    throw new Error('useOpenType must be used within an OpenTypeProvider');
  }
  return context;
};